import { Breadcrumb } from '../../interfaces/breadcrumb'

class BreadcrumbAction {
  
  static UPDATE_BREADCRUMB_TRAIL = 'UPDATE_BREADCRUMB_TRAIL'

  static updateBreadcrumbTrail = (breadcrumbs: Breadcrumb[]) => ({
    type: BreadcrumbAction.UPDATE_BREADCRUMB_TRAIL,
    payload: {
      breadcrumbs: breadcrumbs
    }
  })
}

export default BreadcrumbAction